import { initAlignment } from './index';
import { getState } from '~src/state';
import { DEFAULT_SETTINGS } from '~src/settings/constants';

/**
 * Initialize the modern alignment system
 *
 * @param {fabric.Canvas} canvas - The fabric canvas instance
 * @param {Object} options - Optional configuration
 */
export const initAlignmentSystem = (canvas, options = {}) => {
  // Get current settings from state
  const settings = getState('settings') || DEFAULT_SETTINGS;

  // Merge settings with options
  const alignmentOptions = {
    ...options,
    showAlignmentLines: settings.alignmentLinesEnabled,
    enableObjectAlignment:
      settings.alignmentLinesEnabled &&
      settings.objectAlignmentLinesEnabled !== false,
    enableCenterAlignment:
      settings.alignmentLinesEnabled &&
      settings.canvasAlignmentLinesEnabled !== false,
    showDistanceMeasurements: settings.showDistanceMeasurements,
  };

  // Initialize the new alignment system with correct settings
  const alignmentManager = initAlignment(canvas, alignmentOptions);

  if (!alignmentManager) {
    console.error('Failed to initialize alignment system');
    return;
  }
};
